import { Brands } from '../../../config/brands';
import mainTheme from '../theme';

const theme = {
  ...mainTheme,
  name: Brands.JAMA,
  COLORS: {
    ...mainTheme.COLORS,
    primary: '#2B3990',
    secondary: '#2B3990',
  },
};

export default theme;
